import { RelativePathModel } from '@/react/portainer/gitops/types';

import {
  PORTAINER_EDGE_GROUP_VARIABLE,
  PORTAINER_EDGE_ID_VARIABLE,
} from '../../types';

export function hasDynamicVariable(path: string): boolean {
  return (
    path.includes(PORTAINER_EDGE_GROUP_VARIABLE) ||
    path.includes(PORTAINER_EDGE_ID_VARIABLE)
  );
}

/**
 * Returns the dynamic variable in the path that the GitOps Edge configurations
 * won't resolve at deploy time, if any. Group matching takes priority over device matching.
 */
export function getUnresolvedDynamicVariable(
  path: string,
  relativePath?: RelativePathModel
) {
  const resolvedVariable = getResolvedDynamicVariable(relativePath);

  return [PORTAINER_EDGE_GROUP_VARIABLE, PORTAINER_EDGE_ID_VARIABLE].find(
    (variable) => variable !== resolvedVariable && path.includes(variable)
  );
}

export function renderStyledPath(path: string) {
  // Split the path by dynamic variables and render with styling
  const parts = path
    .split(/(\$\{PORTAINER_EDGE_GROUP\}|\$\{PORTAINER_EDGE_ID\})/g)
    .filter(Boolean);

  return (
    <div className="text-muted mt-1 font-mono text-xs">
      {parts.map((part, index) => {
        if (
          part === PORTAINER_EDGE_GROUP_VARIABLE ||
          part === PORTAINER_EDGE_ID_VARIABLE
        ) {
          return (
            <span
              key={index}
              className="bg-primary-5 text-primary rounded-sm px-1 py-0.5"
              style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)' }}
            >
              {part}
            </span>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </div>
  );
}

function getResolvedDynamicVariable(relativePath?: RelativePathModel) {
  if (!relativePath?.SupportPerDeviceConfigs) {
    return undefined;
  }

  if (relativePath.PerDeviceConfigsGroupMatchType) {
    return PORTAINER_EDGE_GROUP_VARIABLE;
  }

  if (relativePath.PerDeviceConfigsMatchType) {
    return PORTAINER_EDGE_ID_VARIABLE;
  }

  return undefined;
}
